import useDebounce from './useDebounce';

export const useDelayedNameError = (value: string, error: string) => {
    const debouncedValue = useDebounce(value, 400);
    return value === debouncedValue ? error : '';
};

export const nameErrorHelperSx = {
    '&.Mui-error': {animation: 'nameErrorFadeIn 180ms ease-out'},
    '@keyframes nameErrorFadeIn': {from: {opacity: 0}, to: {opacity: 1}},
};
